import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { selectUseAskAiSSEChat } from 'common/selectors';
import { openAskAiSse } from './redux/actions';
import AskAiSSE from './AskAISSE';
import SearchCenter from './SearchCenter';

const AiPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const useAskAiSSEChat = useSelector(selectUseAskAiSSEChat);
  const prevPathnameRef = useRef(null);

  const getAiToolsChatIdFromPath = (pathname) => {
    if (!pathname) return null;
    const match = pathname.match(/\/ai-tools\/(?!files\/)([^/]+)(?:\/|$)/);
    return match ? match[1] : null;
  };

  const getAiToolsChatIdFromFilePath = (pathname) => {
    if (!pathname) return null;
    const match = pathname.match(/\/ai-tools\/(?!files\/)([^/]+)\/files\/[^/]+/);
    return match ? match[1] : null;
  };

  useEffect(() => {
    if (useAskAiSSEChat) {
      const pathname = location?.pathname || '';
      const previousPathname = prevPathnameRef.current;
      prevPathnameRef.current = pathname;

      const isAiToolsFileRoute = /\/ai-tools(\/[^/]+)?\/files\/[^/]+/.test(pathname);
      const wasAiToolsFileRoute =
        previousPathname && /\/ai-tools(\/[^/]+)?\/files\/[^/]+/.test(previousPathname);

      if (wasAiToolsFileRoute && !isAiToolsFileRoute) {
        const previousChatId = getAiToolsChatIdFromFilePath(previousPathname);
        const currentChatId = getAiToolsChatIdFromPath(pathname);
        if (previousChatId && currentChatId && previousChatId === currentChatId) {
          return;
        }
      }

      if (isAiToolsFileRoute) return;
      dispatch(openAskAiSse());
    }
  }, [dispatch, useAskAiSSEChat, location.pathname, location.search]);
  return useAskAiSSEChat ? <AskAiSSE /> : <SearchCenter />;
};

export default AiPage;
